interface SkipLinkProps {
  href: string;
  children: React.ReactNode;
}

export function SkipLink({ href, children }: SkipLinkProps) {
  return (
    <a
      href={href}
      style={{
        position: 'absolute',
        left: '-10000px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        zIndex: 1000,
      }}
      onFocus={(e) => {
        e.currentTarget.style.left = 'var(--space-md)';
        e.currentTarget.style.top = 'var(--space-md)';
        e.currentTarget.style.width = 'auto';
        e.currentTarget.style.height = 'auto';
        e.currentTarget.style.overflow = 'visible';
        e.currentTarget.style.padding = 'var(--space-sm) var(--space-md)';
        e.currentTarget.style.background = 'var(--accent-growth)';
        e.currentTarget.style.color = 'var(--bg-void)';
        e.currentTarget.style.borderRadius = '4px';
        e.currentTarget.style.fontWeight = '600';
        e.currentTarget.style.textDecoration = 'none';
      }}
      onBlur={(e) => {
        e.currentTarget.style.left = '-10000px';
        e.currentTarget.style.width = '1px';
        e.currentTarget.style.height = '1px';
        e.currentTarget.style.overflow = 'hidden';
      }}
    >
      {children}
    </a>
  );
}
